<template>
  <div>
    <div class="z2-conversation-header border-bottom font-16 fw-500">
      <span>
        Kết quả tìm kiếm
        <span class="fw-400">({{ searchMessageData.data ? searchMessageData.data?.length : 0 }})</span>
      </span>
      <div
        class="pointer"
        @click="$emit('closeSearching')">
        <IconV2
          name="v2-close"
          size="20px" />
      </div>
    </div>
    <div class="px-2 mt-2">
      <el-popover
        placement="bottom"
        trigger="click">
        <div>
          <el-date-picker
            v-model="dateRange"
            size="small"
            type="daterange"
            range-separator="-"
            start-placeholder="Ngày bắt đầu"
            end-placeholder="Ngày kết thúc"
            :default-time="['00:00:00', '23:59:59']"
            @change="updateDateRangeValue"></el-date-picker>
        </div>
        <el-tooltip
          slot="reference"
          class="item pointer d-flex justify-content-center align-items-center"
          effect="dark"
          content="Lọc theo thời gian"
          placement="top">
          <el-input
            class="pointer"
            style="min-width: 130px"
            :value="dateRangeValue || 'Tất cả thời gian'"
            placeholder="Tất cả thời gian"
            readonly
            size="small">
            <IconV2
              class="mt-2 ms-1"
              slot="prefix"
              name="v2-date" />
          </el-input>
        </el-tooltip>
      </el-popover>
    </div>

    <div
      v-if="searchMessageData.data && searchMessageData.data.length"
      class="z2-conversation-list">
      <div>
        <MessageSearchItem
          v-for="conversation in searchMessageData.data"
          :key="conversation.lastMessageTime"
          :active="false"
          :accounts="[]"
          searchType="messageInner"
          :conversation="conversation"
          :searchKey="searchMessageData.searchKey"
          @onSelect="onSelectMessage" />
      </div>
    </div>
    <div v-else>
      <div
        v-if="!searchId"
        class="d-flex flex-grow-1 align-items-center justify-content-center"
        style="height: 400px">
        <img src="/assets/images/empty-search-message.svg" />
      </div>
      <div v-else>
        <LoadingConversationV2
          class="w-100 mt-0"
          :num="1"></LoadingConversationV2>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import LoadingConversationV2 from "./LoadingConversationV2.vue";
import MessageSearchItem from "../components/MessageSearchItem.vue";

export default {
  props: ["conversation", "isSearching", "searchMessageData", "searchId"],
  components: {
    LoadingConversationV2,
    MessageSearchItem,
  },
  data() {
    return {
      dateRange: [],
    };
  },
  computed: {
    dateRangeValue() {
      if (!this.dateRange || !this.dateRange.length) return "";
      return moment(this.dateRange[0]).format("DD/MM/YYYY") + " - " + moment(this.dateRange[1]).format("DD/MM/YYYY");
    },
  },
  methods: {
    getTimeToStamp(dateRange) {
      let arrDate = [];
      if (dateRange.length > 0) {
        dateRange.forEach((s) => {
          arrDate.push(new Date(s).getTime());
        });
        return arrDate;
      }
      return [];
    },
    updateDateRangeValue() {
      if (!this.dateRange) {
        this.dateRange = [];
      }
      this.$emit("updateSearchDateRange", this.getTimeToStamp(this.dateRange));
    },
    onSelectMessage(e) {
      this.$emit("onSelectMessage", e)
    }
  },
  created() {
    this.$bus.$on("selectConversationV2", () => {});
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
</style>